// Shared translations for the SMTP relay field blocks (SmtpRelayServerFields, SmtpRelaySenderFields).
// Consumers: mQmarketing (Zugangs-Assistent), m1member (Schnittstellen-Dialog + E-Mail-Konto).
//
// Eigener Schlüsselraum `SmtpRelay.*`: Schlüssel wie „SMTP host" oder „SMTP password" existieren
// bereits in `accessEmailTranslations.ts`. Würden sie hier erneut definiert, hätte eine App, die
// beide Wörterbücher merged, denselben Schlüssel zweimal — und welcher gewinnt, hinge an der
// Reihenfolge im Spread. Die Werte sind wortgleich aus den bestehenden mQmarketing-Wörterbüchern
// übernommen, nur die Schlüssel sind neu.
//
// my-vitalteam nutzt diese Bausteine (noch) nicht, deshalb nur de/en. Kommt es dazu, kommen
// ru/uk/it hinzu.

export const sharedSmtpRelayDe = {
  "SmtpRelay.Host": "SMTP-Server",
  "SmtpRelay.HostPlaceholder": "smtp.beispiel.de",
  "SmtpRelay.HostRequired": "SMTP-Host fehlt.",
  "SmtpRelay.Port": "SMTP-Port",
  "SmtpRelay.PortPlaceholder": "465",
  "SmtpRelay.PortRequired": "SMTP-Port fehlt.",
  "SmtpRelay.UseSsl": "SSL/TLS verwenden",
  "SmtpRelay.Active": "aktiv",
  "SmtpRelay.Inactive": "inaktiv",
  "SmtpRelay.Username": "SMTP-Benutzername",
  "SmtpRelay.UsernamePlaceholder": "SMTP-Login",
  "SmtpRelay.UsernameRequired": "SMTP-Benutzername fehlt.",
  "SmtpRelay.ServerLockedHint": "Die Serverdaten dieses Anbieters stehen fest und werden nicht abgefragt.",
  "SmtpRelay.FromAddress": "Absenderadresse",
  "SmtpRelay.FromAddressPlaceholder": "info@beispiel.de",
  "SmtpRelay.FromAddressRequired": "Bitte eine Absenderadresse eingeben.",
  "SmtpRelay.FromAddressInvalid": "Bitte eine gültige Absenderadresse eingeben.",
  "SmtpRelay.FromName": "Absendername",
  "SmtpRelay.FromNamePlaceholder": "Unternehmensname",
  "SmtpRelay.ReplyToAddress": "Antwortadresse",
  "SmtpRelay.ReplyToAddressPlaceholder": "antworten@beispiel.de",
  "SmtpRelay.ReplyToAddressInvalid": "Bitte eine gültige Antwortadresse eingeben.",
  "SmtpRelay.SenderDomainHint": "Die Domain der Absenderadresse muss beim Anbieter authentifiziert sein, sonst weist er den Versand ab.",
} as const;

export const sharedSmtpRelayEn = {
  "SmtpRelay.Host": "SMTP server",
  "SmtpRelay.HostPlaceholder": "smtp.example.com",
  "SmtpRelay.HostRequired": "SMTP host is required.",
  "SmtpRelay.Port": "SMTP port",
  "SmtpRelay.PortPlaceholder": "465",
  "SmtpRelay.PortRequired": "SMTP port is required.",
  "SmtpRelay.UseSsl": "Use SSL/TLS",
  "SmtpRelay.Active": "active",
  "SmtpRelay.Inactive": "inactive",
  "SmtpRelay.Username": "SMTP username",
  "SmtpRelay.UsernamePlaceholder": "SMTP login",
  "SmtpRelay.UsernameRequired": "SMTP username is required.",
  "SmtpRelay.ServerLockedHint": "This provider's server settings are fixed and are not requested.",
  "SmtpRelay.FromAddress": "Sender address",
  "SmtpRelay.FromAddressPlaceholder": "info@example.com",
  "SmtpRelay.FromAddressRequired": "Enter a sender address.",
  "SmtpRelay.FromAddressInvalid": "Enter a valid sender address.",
  "SmtpRelay.FromName": "Sender name",
  "SmtpRelay.FromNamePlaceholder": "Company name",
  "SmtpRelay.ReplyToAddress": "Reply-to address",
  "SmtpRelay.ReplyToAddressPlaceholder": "reply@example.com",
  "SmtpRelay.ReplyToAddressInvalid": "Enter a valid reply-to address.",
  "SmtpRelay.SenderDomainHint": "The sender address domain must be authenticated with the provider, otherwise it rejects delivery.",
} as const;

export const sharedSmtpRelayTranslations = {
  de: sharedSmtpRelayDe,
  en: sharedSmtpRelayEn,
} as const;

export type SharedSmtpRelayLang = keyof typeof sharedSmtpRelayTranslations;
export type SharedSmtpRelayKey = keyof typeof sharedSmtpRelayDe;
